import { Component, Input, OnInit } from '@angular/core';
import { filter } from 'lodash';
import { combineLatest, Observable, Subject } from 'rxjs';
import { unsubscribeComponent } from '../../../shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import {
  ICollectionToMerge,
  StudentCollectionsMergeService,
} from '../../../shared/services/student-collections-merge/student-collections-merge.service';
import { IFlag } from '../../../shared/typings/interfaces/flags.interface';
import { IStudentAssessment } from '../../../shared/typings/interfaces/student-assessment.interface';
import { IStudentSupport } from '../../../shared/typings/interfaces/student-support.interface';
import { IStudent } from '../../../shared/typings/interfaces/student.interface';
import { IAcademicListStudent } from '../../../store/effects/projections';
import { IConstants } from './academic-mad-lib/academic-mad-lib.interface';

/* istanbul ignore next -- Add to address istanbul bug where constuctor is registering as a branch: https://github.com/istanbuljs/istanbuljs/issues/70 */
@Component({
  selector: 'nvps-academic-list',
  template: require('./academic-list.component.html'),
})
@unsubscribeComponent
export class AcademicListComponent implements OnInit {
  public studentsWithFlagsAndSupports$: Observable<any>;
  public destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() students$: any;
  @Input() flags$: Observable<IFlag[]>;
  @Input() currentSchool: any;
  @Input() studentSupports$: Observable<IStudentSupport[]>;
  @Input() studentAssessments$;
  @Input() schoolAssessments$;
  @Input() currentUser: any;
  @Input() madlibOptions$: any;
  @Input() madlibState$: any;
  @Input() batchActionsMode$: Observable<any>;
  @Input() constants: IConstants;

  constructor(
    private flagsFilterService: FlagsFilterService,
    private studentCollectionsMergeService: StudentCollectionsMergeService,
  ) {}

  ngOnInit(): void {
    this.studentsWithFlagsAndSupports$ = this.mergeStudentsAndCollections(
      this.students$,
      this.flags$,
      this.studentSupports$,
      this.studentAssessments$,
    );
  }

  getFilteredActiveStudentSupports(studentSupports: IStudentSupport[]) {
    return filter(studentSupports, (studentSupport: IStudentSupport) => {
      return studentSupport.status === 'ACTIVE';
    });
  }

  // IAcademicListStudent
  mergeStudentsAndCollections(
    students$: Observable<IStudent[]>,
    flags$: Observable<IFlag[]>,
    studentSupports$: Observable<IStudentSupport[]>,
    studentAssessments$,
  ): Observable<IAcademicListStudent[]> {
    return combineLatest(
      students$,
      flags$,
      studentSupports$,
      studentAssessments$,
      (
        students: IStudent[],
        flags: IFlag[],
        studentSupports: IStudentSupport[],
        studentAssessments: IStudentAssessment[],
      ) => {
        flags = this.flagsFilterService.getFilteredFlags(flags, 'ACADEMIC');
        studentSupports = this.getFilteredActiveStudentSupports(studentSupports);

        const studentsWithMergedCollections = this.studentCollectionsMergeService.mergeCollectionsToStudents({
          students,
          collections: [
            {
              collection: flags,
              keyToAddToStudent: 'flags',
              pathToStudentId: 'studentId',
            } as ICollectionToMerge,
            {
              collection: studentSupports,
              keyToAddToStudent: 'activeStudentSupports',
              pathToStudentId: 'student.studentId',
            } as ICollectionToMerge,
            {
              collection: studentAssessments,
              keyToAddToStudent: 'studentAssessments',
              pathToStudentId: 'student.studentId',
            } as ICollectionToMerge,
          ],
        });
        return studentsWithMergedCollections;
      },
    );
  }
}
